var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{attrs:{"href":_vm.props.row.file_path}},[_vm._v(_vm._s(_vm.props.row.file_name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }